<template>
  <section id="about" class="relative overflow-hidden py-24 px-6 md:px-12">
    <div class="absolute inset-0 pointer-events-none" aria-hidden="true">
      <div class="dandelion dandelion-3 absolute top-[8%] right-[6%] w-28 h-36 sm:w-32 sm:h-40 rotate-[-8deg]" />
      <div class="dandelion dandelion-1 absolute bottom-[10%] left-[4%] w-24 h-32 sm:w-28 sm:h-36 rotate-[6deg]" />
    </div>
    <div class="relative max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-[auto_1fr] gap-12 items-start">
      <div class="flex justify-center md:justify-start">
        <div
          class="w-48 h-48 md:w-56 md:h-56 rounded-full bg-gradient-to-br from-terracotta-100 to-terracotta-200 dark:from-terracotta-900 dark:to-terracotta-800 flex items-center justify-center border border-stone-200 dark:border-stone-800">
          <div class="dandelion dandelion-main w-28 h-32 md:w-32 md:h-40" style="opacity: 1" aria-hidden="true" />
        </div>
      </div>
      <div class="flex flex-col gap-6">
        <h2 class="text-3xl md:text-4xl text-stone-900 dark:text-stone-50">Ma manière de travailler</h2>
        <p class="text-base md:text-lg text-stone-600 dark:text-stone-300 leading-relaxed">
          Lorsqu'une personne pousse la porte de mon cabinet, elle vit une période compliquée, sa souffrance est
          importante, parfois très ancienne. Elle a besoin d'être attentivement écoutée.
        </p>
        <p class="text-base md:text-lg text-stone-600 dark:text-stone-300 leading-relaxed">
          Je considère que chaque situation est singulière. Il n'existe pas une seule manière d'aider, mais différentes
          approches qui peuvent être adaptées en fonction de la personne et de ce qu'elle vit.
        </p>
        <p class="text-base md:text-lg text-stone-600 dark:text-stone-300 leading-relaxed">
          Mon travail consiste d'abord à vous écouter, puis à vous proposer un accompagnement qui me semble le plus
          ajusté. Nous faisons régulièrement le point ensemble, et il est toujours possible de faire évoluer la manière
          de travailler au fil du temps.
        </p>
      </div>
    </div>
  </section>
</template>
